import { useAuthStore } from "../stores/authStore";
import type { CustomerLicence } from "../models/session";

export const useCustomerLicence = (): CustomerLicence | null => {
  return useAuthStore((s) => {
    if (s.status === "loading") return null;
    return s.session.attributes.customerLicence;
  });
};
